import React, { useEffect, useState } from 'react'

import UserFinances from './UserFinances'
import { budgetCalculator } from '../../../helpers/financeCalculator'
import { numberFormatter } from '../../../helpers/numberFormatter'
import UserFinancesByCategory from './UserFinancesByCategory'
import UserBudgetDonutChart from '../../Charts/UserBudgetDonutChart'
import BudgetEditor from './BudgetEditor'
import TotalEquity from './TotalEquity'

function UserBudget({yearParam, monthParam}) {

    const months = [
        {month: "Jan", number: 1}, 
        {month: "Feb", number: 2},
        {month: "Mar", number: 3},
        {month: "Apr", number: 4},
        {month: "Mai", number: 5},
        {month: "Jun", number: 6},
        {month: "Jul", number: 7},
        {month: "Aug", number: 8},
        {month: "Sep", number: 9},
        {month: "Okt", number: 10},
        {month: "Nov", number: 11},
        {month: "Des", number: 12}
    ];
    const years = [2015, 2016, 2017, 2018, 2019, 2020, 2021];
    
    const currentDate = new Date()
    
    const currentMonth = currentDate.getMonth()+1
    const currentYear = currentDate.getFullYear()


    const [show, setShow] = useState(false);

    const [totalExpenses, setTotalExpenses] = useState(0);
    const [totalIncome, setTotalIncome] = useState(0)

    const sumBudget = budgetCalculator(totalIncome, -totalExpenses)
    const [budget, setBudget] = useState(sumBudget)
    const [month, setMonth] = useState(monthParam ? months[+monthParam-1] : currentMonth);
    const [year, setYear] = useState(yearParam ? +yearParam : currentYear)



    useEffect(() => {
        /*
        console.log(currentMonth, currentYear, "Current month, year")
        console.log(month, year, "current month, year, state")
        console.log(monthParam, yearParam, "Current year, month params")
        */


    }, [month, year, currentMonth, currentYear, monthParam, yearParam])

    useEffect(() => {

        if (totalIncome && totalExpenses) {
            setBudget(totalIncome+totalExpenses)
        }

    }, [totalExpenses, totalIncome])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true)
        }
    }

    function monthDisplayNameHandler(monthNum) {

        const monthName = months.filter((month, index) => {
            return monthNum === index+1
        })
        return monthName
    }

    return (
        <div className="my-3">

            <button className="btn btn-success btn-block my-5" onClick={toggle}>
                {show ? "Lukk" : <i className="fas fa-plus"></i>}
            </button>

            {show && (
                <div className="card card-body">
                    <BudgetEditor />
                </div>
            )}

            <div className="text-center my-5 p-4 mask rgba-black-light">
                <p className="text-white">Disponibel inntekt {month && month.name} </p>
                <h2 className={budget > 0 ? "text-white" : budget === 0 ? "text-white" : "text-white"}>{numberFormatter(budget)}</h2>
                <hr />
                <p className="text-white">Disponibel egenkapital</p>
                <h2 className={budget > 0 ? "text-white" : budget === 0 ? "text-white" : "text-white"}><TotalEquity /></h2>
            </div>

            
            <div className="bg-success">
                <h2 className="mt-5 p-4">Total inntekt: <span className="float-right text-white">{totalIncome}</span></h2>
            </div>
            <div className="bg-danger">
                <h2 className="p-4">Total utgift: <span className="float-right text-white">{totalExpenses}</span></h2>
            </div> 
            

            <div className="card card-body">
                <UserBudgetDonutChart />
            </div>

            <UserFinances 
                setTotalExpenses={setTotalExpenses} 
                setTotalIncome={setTotalIncome} 
                months={months} 
                setMonth={setMonth} 
                month={month} 
                years={years}
                year={year}
                setYear={setYear}
            />
            <UserFinancesByCategory month={month} />

        </div>
    )
}
export default UserBudget